import api from "./api";

export interface PayeeData {
    type: string;
    name: string;
    accountNumber: string;
    sortCode: string;
}

export const PayeeApi = api.injectEndpoints({
    endpoints: builder => ({
        verifyPayee: builder.mutation({
            query: (data: PayeeData) => ({
                url: '/payments/payee/verify',
                method: 'post',
                data,
            }),
        }),
    }),
});

export const { useVerifyPayeeMutation } = PayeeApi;
